<template>
  <v-app style="background-color: white;">
    <div style="margin-top:120px" class="bckdiv">
          <p class="txt_my" style="text-align:center;text-transform: uppercase;color:#FFFFFF;font-weight:bold;margin-top: 50px;">
         T r a v e l  &nbsp;&nbsp;a n d  &nbsp;&nbsp;e a t  &nbsp;&nbsp;l i k e  &nbsp;&nbsp;a  &nbsp;&nbsp;l o c a l
       </p>
       <h2 class="txt_my" style="text-align:center;margin-top:-15px;color:#FFFFFF;">
         Top Most Trending International Destinations
       </h2>

       <v-layout wrap style="padding-top: 30px;">
        <v-flex xs12 md3 sm12></v-flex>
        <v-flex xs12 md6 sm12>
          <b-form-input
          style="text-align: center;"
          id="input-1"
          v-model="title"
          type="text"
          placeholder="Search your destination here..."
        ></b-form-input>
        </v-flex>
        <v-flex xs12 md3 sm12></v-flex>
       </v-layout>
      
      </div>
      <v-container>
       <v-layout row wrap>
           <v-flex xs12 sm12 md3 style="padding: 10px;" v-for="des in filteredDestinations" :key="des.id">
            <v-card
              elevation="2"
              style="height: 200px;background-size: cover;color: white;position: relative;width: 100%;"
              :style="{
                backgroundImage: `linear-gradient(to bottom, rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.75)), url(${
                  des.src
                })`
              }"
              @click="view(des)"
            >
              <p style="font-size: 20px;font-weight: bold;">{{ des.title }}</p>
              <p style="font-size: 12px;margin-top: -15px;">{{ des.time }}</p>
              <v-btn
                small
                style="border-radius: 20px !important;color: white;position: absolute; bottom: 10px; left: 10px;"
                dark
                flat
                outline
                >Book Now</v-btn
              >
            </v-card>
           </v-flex>
       </v-layout>
       </v-container>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      title: null,
      internationalList: [],
    };
  },

  methods: {
    view(des) {
      sessionStorage.setItem("Detail", JSON.stringify(des));
      this.$router.push("/packageDetails/"+des.id); // + 
    },
    getData() {
      this.axios
      .get(config.API + "TourPackages2", {
        headers: {
          Authorization: "bearer " + sessionStorage.getItem("token")
        }
      })
      .then(res => {
        console.log("Inter", res.data);
        let _list = res.data;
        let i = _list.length;
        let j = 0;
        let itemAdded = [];
        for (let index = 0; index < _list.length; index++) {
          const element = _list[index];
          itemAdded.push({
            id: element.id,
            name: element.name,
            title: element.name,
            day: element.day,
            night: element.night,
            actualRate: element.actualRate,
            price: element.actualRate,
            rate: element.rate,
            destinationCode: element.destinationCode,
            time: element.day + " Days, " + element.night + " Nights",
            src: config.API + "DestinationUpload/" + element.destinationCode
          })
          j++;
          if(i==j) {
            this.internationalList=itemAdded;
            console.log("internationalList", this.internationalList);
          }
        }
      });
    },
    despkg(des) {
     this.$router.push("/destinationPackage/" + des.id);
    },
  },

  computed: {
    filteredDestinations() {
      if (!this.title) {
        return this.internationalList;
      }
      return this.internationalList.filter(destination =>
        destination.name.toLowerCase().includes(this.title.toLowerCase())
      );
    }
  },

  mounted() {
    this.getData();
    this.$Progress.start();
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap");
@import url("https://fonts.googleapis.com/css?family=Anton&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Alice&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Josefin+Slab:ital,wght@0,100..700;1,100..700&display=swap");
</style>
<style lang="css" scoped>
.tourtheme {
  height: 180px;
  border-radius: 0px;
  margin: 5px;
  background-size: cover;
}
.bckdiv {
    background-image: url("../../assets/aboutus.jpg");
    height: 400px;
    background-size: cover;
}
.hvr:hover {
  cursor: pointer;
  height: 200px;
  /* border : 3px solid; */
  /* border-color: black; */
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
.domImg {
  padding: 5px;
  display: block;
  margin: auto;
  border-radius: 10px;
  height: 180px;
  width: 100%;
}

.domTitle {
  font-family: "Alice", serif !important;
  text-align: left !important;
  font-size: 16px;
  font-weight: 500;
  padding: 5px;
}

.txt_my {
  font-family: "Alice", serif !important;
}
</style>